// extracted by mini-css-extract-plugin
export var myAccount = "style-module--myAccount--979e0";
export var proceed = "style-module--proceed--706fd";
export var success = "style-module--success--94c24";
export var tile = "style-module--tile--99e00";
export var tiles = "style-module--tiles--248c1";